<div class="notification-container" *ngIf="isVisible" [@listAnimation]="notifications.length">
	<app-notification-item
		*ngFor="let notification of notifications; trackBy: trackByNotificationId"
		[notification]="notification"
		(closeNotification)="onCloseNotification($event)"
	></app-notification-item>
</div>
